// extracted by mini-css-extract-plugin
export default {"image":"Enrico_image__V7OYs"};